import React from 'react'
import Image from '@toasttab/shared/src/components/atoms/Image/Image'
import Button from '@toasttab/shared/src/components/atoms/Button/Button'
import { NavHighlightSectionProps } from './ContentfulNavigation'
import './navHighlightSection.css'

const NavHighlightSection = ({
  classes,
  ctaText,
  description,
  image,
  title,
  url
}: NavHighlightSectionProps) => {
  return (
    <div className={classes}>
      <a className='block group' data-testid='NavHighlightSection' href={url}>
        <div className='mb-3'>
          {image ? (
            <div
              className='navHighlightSection-image mb-3'
              data-testid='NavHighlightSection-image'
            >
              <div
                className='navHighlightSection-imageBorder'
                data-testid='NavHighlightSection-imageBorder'
              />
              <Image
                classes='rounded-md h-full'
                imageAlt=''
                imgClasses='rounded-md'
                objectCover={false}
                scaleHover={false}
                url={image}
              />
            </div>
          ) : null}
          <h4 className='heading-4 text-default'>{title}</h4>
          {description ? (
            <p className='text-secondary mt-1'>{description}</p>
          ) : null}
        </div>
        {ctaText && url ? (
          <Button isDecorative size='medium' variation='secondary'>
            {ctaText}
          </Button>
        ) : null}
      </a>
    </div>
  )
}

export default NavHighlightSection
